import { api } from "./api";

export interface RelatorioMovimentoOficial {
  id: string;
  id_militar: string;
  militar: any;
  status: string;
  tipo_atividade: string | null;
  id_grupo: string | null;
  grupo: any | null;
  descricao_atividade: string | null;
  data_hora_inicio: string;
  data_hora_termino: string | null;
  created_at: string;
  updated_at: string;
}

export interface RelatorioMovimentoOficialResponsavel {
  id: string;
  id_militar: string;
  militar: any;
  data_hora_inicio: string;
  data_hora_termino: string | null;
  status: string;
  data_hora_pausa: string | null;
  tempo_pausado_segundos: number;
  created_at: string;
  updated_at: string;
}

export const relatorioMovimentoOficialService = {
  // Responsabilidade RMO
  async getResponsavelAtual() {
    const response = await api.get("/relatorio-movimento-oficial/responsavel/atual");
    return response.data;
  },

  async iniciarRMO() {
    const response = await api.post("/relatorio-movimento-oficial/responsavel/iniciar");
    return response.data;
  },

  async pegarRMO() {
    const response = await api.post("/relatorio-movimento-oficial/responsavel/pegar");
    return response.data;
  },

  async pausarRMO() {
    const response = await api.patch("/relatorio-movimento-oficial/responsavel/pausar");
    return response.data;
  },

  async retomarRMO() {
    const response = await api.patch("/relatorio-movimento-oficial/responsavel/retomar");
    return response.data;
  },

  async finalizarRMO() {
    const response = await api.delete("/relatorio-movimento-oficial/responsavel/finalizar");
    return response.data;
  },

  async getHistoricoResponsaveis(params?: {
    data_inicio?: string;
    data_fim?: string;
    page?: number;
    limit?: number;
  }) {
    const response = await api.get("/relatorio-movimento-oficial/responsavel/historico", { params });
    return response.data;
  },

  // Status RMO
  async updateStatus(data: {
    status: string;
    tipo_atividade?: string;
    id_grupo?: string;
    descricao_atividade?: string;
  }) {
    const response = await api.patch("/relatorio-movimento-oficial/status", data);
    return response.data;
  },

  async getStatusAtual() {
    const response = await api.get("/relatorio-movimento-oficial/status/atual");
    return response.data;
  },

  async getAllStatus() {
    const response = await api.get("/relatorio-movimento-oficial/status/todos");
    return response.data;
  },

  async getHistoricoMilitar(id_militar: string, params?: {
    data_inicio?: string;
    data_fim?: string;
    page?: number;
    limit?: number;
  }) {
    const response = await api.get(`/relatorio-movimento-oficial/historico/${id_militar}`, { params });
    return response.data;
  },

  async updateStatusMilitar(id_militar: string, data: {
    status: string;
    tipo_atividade?: string;
    id_grupo?: string;
    descricao_atividade?: string;
  }) {
    const response = await api.patch(`/relatorio-movimento-oficial/status/${id_militar}`, data);
    return response.data;
  },

  async ajustarHorariosRegistro(id: string, data: {
    data_hora_inicio: string;
    data_hora_termino: string | null;
  }) {
    const response = await api.patch(`/relatorio-movimento-oficial/registro/${id}/horarios`, data);
    return response.data;
  },
};
